import React, { useState} from 'react';
import {makeStyles} from 'tss-react/mui';
import {   Paper, Table, TableBody, TableCell, 
        TableContainer, TableHead, TableRow,  } from '@mui/material';
import {useNavigate} from "react-router-dom";
const useStyles = makeStyles({
    root: {
        width: '8rem',
    },
    container: {
        maxHeight: window.innerHeight - 170,
        minHeight: 280,
        width: '8rem',
     
    },
    container2: {
        maxHeight: 550,
    },
    tableRow: {
        "&$selected, &$selected:hover": {
            backgroundColor: "#0F82EE",
            color:"white"
        }
    },
    tableCell: {
        "$selected &": {
               color: "#0F82EE",
               color: "white"
        }
    },
    hover: {},
    selected: {}
});

export default function TablaPerfilTipo({  datos,setTipoSelect,tipoSelect}) {
    const classes = useStyles();
    let history = useNavigate();
    const [selectedID, setSelectedID] = useState(null);
 
   // const [datos, setDatos] = useState([])
    let nvlSNPermiso = '5'   
    React.useEffect(()=>{
        setSelectedID(null)
        //console.log(datos);
    },[datos])
    const seleccionado = (auxId, auxOrden) => {
       // setSelectedID(auxId)
        setTipoSelect(auxOrden)
    }
 
    const celda=(alinear,estilo,campo,key,clasess)=>{
        return<TableCell component="th" key={key} scope="row" clasess={clasess} align={alinear} sx={estilo}>{campo}</TableCell>
    }
    function Row(props) {
        const {row} = props;
        //console.log(row);
        return (        
        <TableRow onClick={() => { seleccionado(row.Id, row) }}
            sx={{"&.Mui-selected, &.Mui-selected:hover": {
                backgroundColor: (theme) => theme.palette.primary.light,
                "& > .MuiTableCell-root": {
                    color: (theme) => theme.palette.secondary.contrastText,
                }
            }}}
            className={classes.tableRow} selected={ tipoSelect?.Id === row.Id}
            classes={{hover: classes.hover, selected: classes.selected}}
        >  
            {celda("left", {padding:.3+'rem', paddingLeft:"10px" }, row.Nom, 5, classes.tableCell)}                    
        </TableRow>           
      
        );
    }

    function tablaCompleta(auxlista) {
        return (
        <TableContainer className={classes.container} component={Paper}>
        <Table  aria-label="sticky table">
            <TableHead sx={{ backgroundColor: (theme) => theme.palette.secondary.main, padding: '0.2rem'}} >
                <TableRow>                 
                    <TableCell align="center" padding='none' sx={{ color: (theme) => theme.palette.secondary.contrastText}}>Categoría</TableCell>    
                </TableRow>
            </TableHead>
            <TableBody>
                {auxlista.length !== 0 ? (auxlista.map((row) => (
                    <Row key={row.Id} row={row}/>
                ))) : null}
            </TableBody>
        </Table>
        </TableContainer>
        )
    }

    const tablaSinDatos = () => {
        return (
        <TableContainer className={classes.container2}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>            
                    <TableCell align="left">Tipo</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow className={classes.tableRow}>
                    {celda("left", {}, "Sin Perfiles", 1, classes.tableCell)}                 
                </TableRow>
            </TableBody>
        </Table>
        </TableContainer>
        )
    }    

    const contenido = datos.length !== 0 ? tablaCompleta(datos) : tablaSinDatos()

    return (
    <span>
        {contenido}
    </span>
    );
}